import { initI18n } from '@referee/i18n';
import en from './locales/en.json';
import de from './locales/de.json';
import es from './locales/es.json';
import pt from './locales/pt.json';

const i18n = initI18n({
  resources: {
    en: { translation: en },
    de: { translation: de },
    es: { translation: es },
    pt: { translation: pt },
  },
  supportedLngs: ['en', 'de', 'es', 'pt'],
});

export default i18n;
